export default __webpack_public_path__ + "static/media/left_test.a0754a0a.png";